import React from 'react';
import { ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ordensServicoService } from '../../services';

export const OrdensServicoFormPage: React.FC = () => {
  return (
    <ResourceFormPage
      title="Ordem de Serviço"
      service={ordensServicoService}
      redirectPath="/admin/logistica/ordens-servico"
      fields={[
        { name: 'veiculo', label: 'Veículo', type: 'select', required: true },
        { name: 'tipo_servico', label: 'Tipo de Serviço', type: 'select', options: [
          { value: 'PREVENTIVA', label: 'Preventiva' },
          { value: 'CORRETIVA', label: 'Corretiva' },
          { value: 'EMERGENCIAL', label: 'Emergencial' },
          { value: 'REVISAO', label: 'Revisão' },
        ]},
        { name: 'prioridade', label: 'Prioridade', type: 'select', options: [
          { value: 'BAIXA', label: 'Baixa' },
          { value: 'MEDIA', label: 'Média' },
          { value: 'ALTA', label: 'Alta' },
          { value: 'URGENTE', label: 'Urgente' },
        ]},
        { name: 'status', label: 'Status', type: 'select', options: [
          { value: 'ABERTA', label: 'Aberta' },
          { value: 'EM_ANDAMENTO', label: 'Em Andamento' },
          { value: 'AGUARDANDO_PECA', label: 'Aguardando Peça' },
          { value: 'CONCLUIDA', label: 'Concluída' },
          { value: 'CANCELADA', label: 'Cancelada' },
        ]},
        { name: 'data_inicio', label: 'Data de Início', type: 'date' },
        { name: 'data_fim', label: 'Data de Fim', type: 'date' },
        { name: 'descricao', label: 'Descrição', type: 'textarea', required: true },
        { name: 'responsavel', label: 'Responsável', type: 'select' },
        { name: 'custo_estimado', label: 'Custo Estimado', type: 'number' },
        { name: 'custo_real', label: 'Custo Real', type: 'number' },
        { name: 'observacoes', label: 'Observações', type: 'textarea' },
      ]}
    />
  );
};
